/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MixedInputs */

const cs_enum_mixed = /** @type {(inputs: Enum_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smíšená`)
};

const en_enum_mixed = /** @type {(inputs: Enum_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixed`)
};

/**
* | output |
* | --- |
* | "Mixed" |
*
* @param {Enum_MixedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_mixed = /** @type {((inputs?: Enum_MixedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MixedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_mixed(inputs)
	return cs_enum_mixed(inputs)
});